export enum ClientsStatuses {
  active = 'active',
  blocked = 'blocked',
  request = 'removing_requested',
  removed = 'removed',
}
